import { render } from "./History.vue?vue&type=template&id=44f8d066"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"
script.render = render

export default script